import React from "react";
import NotificaionsTable from "./Components/NotificationTable";


const Notificaions: React.FunctionComponent = () => {
  return <NotificaionsTable />;
};

export default Notificaions;
